<wbo-edit-page #editPage [title]="model.data.name" [formGroup]="editPage.formGroup">
    <fui-formation-group [title]="'wbo.order-action-display.edit.formation.details'" [formControlNames]="''">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control [(ngModel)]="model.data.name"
                                               formControlName="name"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-numeric-edit-control [(ngModel)]="model.data.displayedHours"
                                                  [notation]="'wbo.common.label.hours' | translate"
                                                  formControlName="displayedHours"></wbo-numeric-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-site-single-select-edit-control [(ngModel)]="model.data.site"
                                                             [readonlyOnEdit]="true"
                                                             (valueChange)="changeSite()"
                                                             formControlName="site"></wbo-site-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column
                                [label]="'wbo.order-action-display.edit.field-set.orderLocation'">
                        <wbo-outlet-multi-select-edit-control formControlName="outletIds"
                                                              [(ngModel)]="model.data.outletIds"
                                                              (valueChange)="outletsChanged()">
                        </wbo-outlet-multi-select-edit-control>
                        <fui-message-label [title]="'wbo.common.label.or'"></fui-message-label>
                        <wbo-terminal-multi-select-edit-control formControlName="terminalIds"
                                                                [(ngModel)]="model.data.terminalIds"
                                                                (valueChange)="terminalsChanged()">
                        </wbo-terminal-multi-select-edit-control>
                        <fui-message-label [title]="'wbo.common.label.or'"></fui-message-label>
                        <wbo-web-terminal-multi-select-edit-control formControlName="webTerminalIds"
                                                                 [site]="model.data.site"
                                                                 [excludeAssignedSites]="!model.data.site"
                                                                 [(ngModel)]="model.data.webTerminalIds"
                                                                 (valueChange)="webTerminalsChanged()">
                        </wbo-web-terminal-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-columns>
                    <fui-column [label]="'wbo.order-action-display.edit.field-set.actions'">
                        <wbo-edit-grid [endCommandColumnWidth]="80"
                                       [data]="model.data.actions"
                                       [entityPath]="'actions'"
                                       [editable]="true"
                                       [removable]="true">
                            <wbo-single-select-column [editable]="false"
                                                      field="actionType">
                                <wbo-order-action-type-select-options></wbo-order-action-type-select-options>
                            </wbo-single-select-column>
                            <wbo-text-column [editable]="false" [showPlaceholderForCell]="false"
                                             field="label"></wbo-text-column>
                            <wbo-column [editable]="false" field="description">
                                <ng-template cellTemplate let-dataItem="dataItem">
                                    {{dataItem.actionType === OrderActionType.PAGE_CUSTOMER ?
                                        (orderActionNotificationMessage(dataItem) | translate: {
                                            description: dataItem.description || '',
                                            location: dataItem.location
                                        }) : ''
                                    }}
                                </ng-template>
                            </wbo-column>
                            <wbo-edit-grid-add-row [editOnAdd]="true" [identifierField]="'id'">
                                <wbo-edit-grid-add-row-actions>
                                    <wbo-edit-grid-add-row-new>
                                    </wbo-edit-grid-add-row-new>
                                </wbo-edit-grid-add-row-actions>
                            </wbo-edit-grid-add-row>
                            <ng-template gridFormTemplate let-dataItem="dataItem" let-formGroup="formGroup"
                                         let-isNew="isNew">
                                <wbo-order-action-edit-form [orderAction]="dataItem"
                                                            [formGroup]="formGroup"></wbo-order-action-edit-form>
                            </ng-template>
                        </wbo-edit-grid>
                    </fui-column>
                </fui-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>
